<template>
    <v-dialog 
        :value="show"
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="close">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span v-if="editedItem && editedItem.RoleTypeID">Edit Role</span>
                    <span v-else>Add New Role</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="editForm" v-model="editValid">
                <v-layout class="dialog-content">
                    <v-flex xs12 md6 offset-md3 mt-4>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field 
                                    label="Role Name"
                                    :value="editedItem.Name"
                                    disabled>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    label="Companies"
                                    :items="companies"
                                    item-value="CompanyID"
                                    item-text="CompanyName"
                                    v-model="editedItem.CompanyID"
                                >
                                </v-select>
                            </v-flex> 
                            <v-flex xs12>
                                <v-autocomplete
                                    label="Work Types"
                                    :items="$Constants.WORK_TYPES_ARRAY_NO_EXTRAS"
                                    item-value="WorkTypeID"
                                    item-text="Name"
                                    v-model="editedItem.WorkTypeID"
                                    disabled
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    label="Role Type Categories"
                                    :items="roleTypeCategories"
                                    item-value="RoleTypeCategoryID"
                                    item-text="RoleTypeCategoryName"
                                    v-model="editedItem.RoleTypeCategoryID"
                                >
                                </v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    label="Alternative Role Type"
                                    :items="alternativeRoles"
                                    item-value="RoleTypeID"
                                    :item-text="alternativeRoleName"
                                    v-model="editedItem.AlternativeRoleTypeID"
                                >
                                </v-select>
                            </v-flex>                              

                            <v-flex xs12>
                                <v-text-field 
                                    label="Account Code"
                                    :value="editedItem.AccountCode"
                                    disabled>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
                                    label="Salary Code"
                                    :items="salaryCodes"
                                    item-value="SalaryCodeID"
                                    item-text="SalaryCode"
                                    v-model="editedItem.DefaultSalaryCodeID"
                                >
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="success" 
                                    :disabled="!editValid" 
                                    :loading="saving" 
                                    @click="save">
                                    <span>Save</span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="error" 
                                    :disabled="saving" 
                                    @click="close">
                                    <span>Cancel</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-alert 
                                    :value="error" 
                                    outline 
                                    type="error">
                                    <span>{{ error }}</span>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import ConfigurationAPI from "@/api/configurationApi";
import BaseAPI from "@/api/baseApi";
import * as Constants from "@/helpers/constants";
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        salaryCodes: {
            required: true,
            type: Array
        },
        originalItem: {
            required: false,
            type: Object,
            default: null
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        },
        companies: {
            required: true,
            type: Array
        },
        roleTypeCategories: {
            required: true,
            type: Array
        },
        roles: {
            require: true,
            type: Array
        }
    },
    data() {
        return {
            editedItem: {},

            saving: false,
            error: null,

            editValid: false

        }
    },
    computed: {
        alternativeRoles() {
            if(this.editedItem) {
                return this.roles.filter(r=> r.CompanyID == this.editedItem.CompanyID && r.WorkTypeID != this.editedItem.WorkTypeID)
            } else {
                return [];
            }
        }
    },
    mounted() {
        
    },
    methods: {
        close(saved) {
            this.$emit("close", saved);
        },
        async save() {
            try {
                this.saving = true;
                this.error = null;

                await ConfigurationAPI.saveRole(this.editedItem);

                this.close(true);
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.saving = false;
            }
        },
        alternativeRoleName(item) {
            return `${item.Name} (${item.WorkTypeName})`
        }
    },
    watch: {
        show: {
            handler(newVal, oldVal) {
                if (newVal != oldVal && newVal) {
                    this.editedItem = Object.assign({}, this.originalItem);
                }
            },
            deep: true
        },
        editedItem: {
            // always watch out for this issue: https://github.com/vuejs/vue/issues/2164
            handler(newVal) {
                if (newVal.WorkTypeID == Constants.WORK_TYPES.PICKING.WorkTypeID && newVal.CompanyID != Constants.COMPANIES.CHINA.CompanyID) {
                    this.editedItem.DefaultPayRatePerHour = null;
                }
            },
            deep: true
        }
    },
}
</script>